import metadata from '@/data/metadata';

type Social = {
  name: string;
  href: string;
  external: boolean;
};

const social: Social[] = [
  {
    name: "LinkedIn",
    href: metadata.social.linkedin,
    external: true,
  },
  {
    name: "GitHub",
    href: metadata.social.github,
    external: true,
  },
  {
    name: "X",
    href: metadata.social.twitter,
    external: true,
  },
  {
    name: "Contact",
    href: "contact",
    external: false,
  }, 
];

export default social;